import { useEffect, useState } from 'react';
import http from 'src/services/httpService';
import errorHandler from 'src/utils/errorHandler';

import secoesRegistry from './SecoesRegistry';

const SecoesDossieColaborador = ({ colaboradorId }) => {
  const [secoes, setSecoes] = useState([]);
  const [colaborador, setColaborador] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getSecoes();
    getInformacoesColaborador();
  }, []);

  const getSecoes = async () => {
    try {
      const response = await http.get(
        'DossieColaborador/ObterSecoesDossieColaborador'
      );

      setSecoes(response?.data?.sort((a, b) => a.ordem - b.ordem));
    } catch (error) {
      errorHandler(error);
    }
  };

  const getInformacoesColaborador = async () => {
    try {
      setIsLoading(true);
      const response = await http.post(
        `Colaborador/ObterInformacoesComplementares`,
        {
          colaboradorId,
        }
      );
      setColaborador(response?.data);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      errorHandler(error);
    }
  };

  return (
    <div className="w-100">
      {secoes?.map((secao, index) => {
        const SectionComponent = secoesRegistry[secao?.secao];
        if (!SectionComponent) {
          return null;
        }

        if (!secao?.visivel) return null;

        return (
          <div key={secao?.id} className="mb-4">
            <SectionComponent colaborador={colaborador} isLoading={isLoading} />
          </div>
        );
      })}
    </div>
  );
};

export default SecoesDossieColaborador;
